import React, { useState } from "react";
import { useNavigate, Navigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Lock, Shield } from "lucide-react";

export default function Login() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return <div className="brutal-card p-10 text-center font-mono-display uppercase tracking-widest">Checking the hatch...</div>;
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await login(email.trim(), password);
      navigate("/");
    } catch (err) {
      const detail = err.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : (Array.isArray(detail) ? detail[0]?.msg : "Login failed.");
      setError(msg || "Login failed.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="max-w-md mx-auto" data-testid="login-page">
      <div className="brutal-card p-6 md:p-8">
        <div className="flex items-center gap-3 mb-1">
          <div className="bg-pink-500 text-white brutal-border w-10 h-10 flex items-center justify-center">
            <Shield size={18} strokeWidth={3} />
          </div>
          <div>
            <div className="font-mono-display text-xs uppercase tracking-[0.25em] text-pink-600">
              Authorized Personnel Only
            </div>
            <h1 className="font-mono-display text-2xl font-bold tracking-tighter uppercase">Admin Login</h1>
          </div>
        </div>
        <p className="text-sm text-slate-700 mb-5 mt-3">
          Sign in to edit episode info, edit or delete community sections.
        </p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="font-mono-display text-xs uppercase tracking-widest block mb-1">Email</label>
            <input
              type="text"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="brutal-input"
              placeholder="admin@kimmypedia.local"
              autoFocus
              data-testid="login-email"
            />
          </div>
          <div>
            <label className="font-mono-display text-xs uppercase tracking-widest block mb-1">Password</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="brutal-input"
              placeholder="••••••••"
              data-testid="login-password"
            />
          </div>
          {error && (
            <div className="brutal-border bg-red-100 text-red-900 px-3 py-2 font-mono-display text-xs uppercase tracking-wider" data-testid="login-error">
              ! {error}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="brutal-btn primary w-full justify-center"
            data-testid="login-submit"
          >
            <Lock size={16} strokeWidth={3} />
            {submitting ? "Signing in..." : "Enter the Bunker"}
          </button>
        </form>
        <div className="mt-5 pt-5 border-t-2 border-slate-900 text-xs text-slate-600">
          <Link to="/" className="wiki-link">← Back to Kimmypedia</Link>
        </div>
      </div>
    </div>
  );
}
